"use client";
import { getRelativePathFromLink } from "./url";
import {
  getDomainForLocale,
  isLocaleDomainMapped,
  isMultiDomainEnabled,
  stripLocalePrefix,
} from "./localeDomains";
import { Post } from "@aleksundshantu/gp-types/client";

/**
 * **Path Translator**
 * @returns *available translations for the current page*
 *
 * With NEXT_PUBLIC_LOCALE_DOMAINS set, paths are absolute cross-domain URLs
 * (locale prefix stripped for mapped locales) so switching languages also
 * switches to the correct domain.
 */
export const pathTranslator = (post: Post) => {
  const availableTranslations: { lang: string; path: string }[] = [];

  if (!post) return availableTranslations;

  if (post.wpml_translations) {
    post.wpml_translations.map((info) => {
      if (
        (process.env.NEXT_PUBLIC_LOCALES?.split(",") ?? ["de"]).some(
          (l) => l === info.locale.split("_")[0],
        )
      ) {
        const lang = info.locale.split("_")[0];
        const relativePath = getRelativePathFromLink(info.href);
        const path = isMultiDomainEnabled()
          ? `${getDomainForLocale(lang)}${
              isLocaleDomainMapped(lang)
                ? stripLocalePrefix(relativePath, lang)
                : relativePath
            }`
          : relativePath;
        availableTranslations.push({ lang, path });
      }
    });
  }

  return availableTranslations;
};

export const dynamicPath = (href: string) => {
  const url = href.split("/");
  if (url[url.length - 1] !== "") {
    // Url has no / at the end
    return url[url.length - 1];
  } else {
    // Url has / at the end
    return url[url.length - 2];
  }
};
